module.exports = {"DEFAULT_LANGUAGE":"en","SUPPORTED_LANGUAGES":["en","ru","uk","da","ro"],"RPC_ENDPOINT":"/jsonrpc-api/core/v1/","GET_ENV_VARS_URL":"/backend/env-vars.js"}


//////////////////
// WEBPACK FOOTER
// ./.environment.json
// module id = ZiIs
// module chunks = 1